<template>
    <div id="new-order">

        <b-modal hide-footer ref="my-modal" size="xl" title="Validation commande" scrollable>
            <b-table fixed responsive :bordered="true" :small="true" :no-border-collapse="true"
                :items="agGrid.rows.filter(row => row.No !== '')" :fields="fields">
                <template #table-colgroup="scope">
                    <col v-for="field in scope.fields" :key="field.key"
                        :style="{ width: field.key === 'Description' ? '200px' : '100px' }">
                </template>
                <template #cell(Total)="data">
                    {{ formatPrice(data.item.Unit_Price_pharmacien_TTC * data.item.Qte) }}
                </template>

                <template #cell(#)="data">
                    <b-button size="sm" @click="data.toggleDetails">
                        Détails
                    </b-button>
                </template>
                <template #row-details="data">
                    <b-card>
                        <!-- {{ data }} -->
                        <b-row>
                            <b-col cols="4">
                                <ul>
                                    <li>Fournisseur : {{ data.item.Nom_Fournisseur }}</li>
                                    <li>Catégorie : {{ data.item.Family }}</li>
                                    <li>Famille : {{ data.item.Subfamily }}</li>
                                </ul>
                            </b-col>
                            <b-col cols="4">
                                <ul>
                                    <li>Prix H.T : {{ data.item.Unit_Price_pharmacien }}</li>
                                    <li>Prix T.T.C : {{ data.item.Unit_Price_pharmacien_TTC }}</li>
                                    <li>Prix Public : {{ data.item.Prix_Public }}</li>
                                </ul>
                            </b-col>
                            <b-col cols="4">
                                <ul>
                                    <li>DLC : {{ data.item.DLC }}</li>
                                    <li>DCI : {{ data.item.DCI }}</li>
                                    <li>PCT : {{ data.item.Code_PCT }}</li>
                                </ul>
                            </b-col>
                        </b-row>
                    </b-card>
                </template>

                <template slot="bottom-row">
                    <td><b>TOTAL</b></td>
                    <td style=" border-right: none;"></td>
                    <td style=" border-left: none;"></td>
                    <!-- this is a computed prop that adds up all the expenses in the visible rows -->
                    <td><b>{{ formatPrice(totalExpenses) }}</b></td>
                    <td style=" border-left: none;"></td>
                </template>

            </b-table>
            <b-row class="text-right">
                <b-col md="12" lg="9" class="text-left" style="margin-bottom: 5px;">
                    <b-form-input v-model="observation" placeholder="Observation" type="text" />
                </b-col>
                <b-col md="12" lg="3">
                    <b-button @click="saveOrder" variant="gradient-success" block>
                        Valider La Commande
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>


        <b-overlay :show="showLoading" spinner-variant="primary">

            <b-card>
                <b-row>
                    <b-col cols="9">
                        <products-select @productClicked="productClicked" ref="productsSelect" />
                    </b-col>
                    <b-col class="text-right" cols="3">
                        <b-button :disabled="disableOrderBtn" @click="openModal" variant="gradient-success">
                            Commander
                        </b-button>
                    </b-col>
                </b-row>

                <ag-grid :showHeader="false" :agGrid="agGrid" pageTitle="Liste des articles" ref="agGrid" />

            </b-card>

        </b-overlay>
    </div>
</template>

<script>

import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import ProductsSelect from './ProductsSelect.vue';
import NumericEditor from './NumericEditor.js'
import IconCellRenderer from "@/views/components/ag-grid/IconCellRenderer.vue";
import ButtonCellRenderer from "@/views/components/ag-grid/ButtonCellRenderer.vue"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BadgeCellRenderer from "@/views/components/ag-grid/BadgeCellRenderer.vue";
import { getOrders, deleteOrders, saveOrders } from '@/utils/indexDB/index';
import { formatPrice } from "@/utils/formatting";

export default {
    components: {
        AgGrid,
        ProductsSelect
    },
    data() {
        return {
            totalExpenses: 0,
            disableOrderBtn: true,
            formatPrice: formatPrice,
            observation: "",
            fields: [{
                key: 'Description',
                label: 'Article',
                sortable: true
            },
            {
                key: 'Unit_Price_pharmacien_TTC',
                label: 'Prix',
                sortable: true
            },
            {
                key: 'Qte',
                label: 'Qte',
                sortable: true
            },
            {
                key: 'Total',
                label: 'Total',
                sortable: true
            },
            {
                key: '#',
                label: '#',
            },
            ],
            showLoading: true,
            agGrid: {
                singleClickEdit: true,
                columnDefs: [
                    {
                        headerName: "",
                        field: "state",
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'iconCellRenderer',
                        cellRendererParams: { componentName: "NewOrder" },
                        width: 20,
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                    },
                    // {
                    //     headerName: "N°",
                    //     field: "No",
                    //     width: 60,
                    //     cellClassRules: {
                    //         'noborder-customeCellRender': function (params) {
                    //             return params.data.No === ''; // Apply class for the first row (index 0)
                    //         }
                    //     },
                    // },
                    {
                        headerName: "Description",
                        field: "Description",
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                    },
                    {
                        headerName: "Gratuité",
                        field: "promotion",
                        cellRendererFramework: 'badgeCellRenderer',
                        cellRendererParams: { componentName: "NewOrder", columnName: "promotion" },
                        width: 55,
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                    },
                    {
                        headerName: "Famille",
                        field: "Family",
                        width: 60,
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                    },
                    {
                        headerName: "Quantité",
                        field: "Qte",
                        editable: params => params.data.No != "",
                        cellEditor: NumericEditor,
                        width: 100,
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                    },
                    {
                        headerName: "Prix H.T",
                        field: "Unit_Price_pharmacien",
                        valueGetter: function (tr) {
                            if (tr.data.No != "")
                                return formatPrice(tr.data.Unit_Price_pharmacien);
                        },
                        width: 60,
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                    },
                    {
                        headerName: "Prix T.T.C",
                        field: "Unit_Price_pharmacien_TTC",
                        valueGetter: function (tr) {
                            if (tr.data.No != "")
                                return formatPrice(tr.data.Unit_Price_pharmacien_TTC);
                        },
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                        width: 60
                    },
                    {
                        headerName: "Prix public",
                        field: "Prix_Public",
                        valueGetter: function (tr) {
                            if (tr.data.No != "")
                                return formatPrice(tr.data.Prix_Public);
                        },
                        width: 60,
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                    },
                    {
                        headerName: "D.L.C",
                        field: "DLC",
                        width: 60,
                    },
                    {
                        headerName: "Cartonnage",
                        field: "Packaging",
                        width: 40,
                    },
                    {
                        headerName: "Total",
                        field: "total",
                        valueGetter: function (tr) {
                            if (tr.data.No != "")
                                return formatPrice(tr.data.Unit_Price_pharmacien_TTC * tr.data.Qte);
                            else {
                                // Calcul du total pour la ligne de pied de page
                                let total = 0;
                                tr.api.forEachNode(function (node) {
                                    if (node.data.No !== '') {
                                        total += node.data.Qte * node.data.Unit_Price_pharmacien_TTC;
                                    }
                                });
                                return formatPrice(total);
                            }
                        },
                        // cellStyle: function (params) {
                        //     if (params.node.data.No === "") {
                        //         return {
                        //             // fontWeight: "bold",
                        //             // border: "1px solid #6e6b7b",
                        //         };
                        //     } else {
                        //         return null; // No styling for the total row
                        //     }
                        // },
                        width: 60
                    },
                    {
                        sortable: false,
                        resizable: false,
                        filter: false,
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'buttonCellRenderer',
                        cellRendererParams: { componentName: 'NewOrder', onButtonClick: this.deleteProduct, icon: "backspace", variant: "outline-danger" },
                        headerName: '',
                        width: 40,
                        cellClassRules: {
                            'noborder-customeCellRender': function (params) {
                                return params.data.No === ''; // Apply class for the first row (index 0)
                            }
                        },
                    }
                ],
                rows: []
            },
        }
    },
    computed: {
        // saveOrderValidation() {
        //     return this.agGrid.rows.some((item) => {
        //         return !item.state && item.No !== "";
        //     });
        // },
    },
    beforeDestroy() {
        const gridApi = this.$refs.agGrid.gridApi;
        gridApi.removeEventListener("cellKeyPress", this.cellKeyPress);
        this.saveDataToIndexDB();
    },
    created() {
        this.$options.components.iconCellRenderer = IconCellRenderer;
        this.$options.components.buttonCellRenderer = ButtonCellRenderer;
        this.$options.components.badgeCellRenderer = BadgeCellRenderer;
        this.loadData();
    },
    methods: {
        openModal() {
            this.totalExpenses = this.agGrid.rows.reduce((accum, item) => {
                if (item.No !== "") {
                    const totalPrice = parseFloat(item.Unit_Price_pharmacien_TTC) * parseFloat(item.Qte);
                    return accum + totalPrice;
                } else {
                    return accum;
                }
            }, 0.00);
            this.$refs['my-modal'].show();
        },
        saveOrder() {
            this.$refs['my-modal'].hide();
            this.showLoading = true;
            let orderDto = {
                lines: [],
                observation: this.observation
            };
            let lines = this.agGrid.rows.map(function (obj) {
                return {
                    no: obj.No,
                    qte: parseInt(obj.Qte)
                };
            });
            orderDto.lines = lines;
            this.$http.post("order", orderDto).then((response) => {
                this.showLoading = false;
                if (response.data.no) {
                    this.agGrid.rows.find(item => item.No === response.data.no).state = false;
                    let row = this.agGrid.rows.find(item => item.No === response.data.no);
                    row.state = false;
                    this.confirmSwall = this.$swal({
                        icon: 'error',
                        title: "Oups ! La quantité demandée de l'article " + row.Description + " n'est plus disponible pour le moment.",
                        timer: 15000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    });
                } else {
                    this.agGrid.rows = [];
                    this.confirmSwall = this.$swal({
                        icon: 'success',
                        title: "Votre commande a été soumise avec succès. Nous la traiterons rapidement.",
                        timer: 10000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    });
                }
                this.disableBtn();
            }).catch((error) => {
                console.log(error);
                this.disableBtn();
                this.showLoading = false;
                this.$swal({
                    title: "Erreur s'est produite lors de la récupération des données",
                    text: error.response.data,
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                });
            });
        },
        saveDataToIndexDB() {
            deleteOrders();
            if (this.agGrid.rows.length > 0)
                saveOrders(this.agGrid.rows.filter(item => item.No != ""));
        },
        deleteProduct(data) {
            const index = this.agGrid.rows.findIndex(product => product === data);
            if (index !== -1) {
                this.agGrid.rows.splice(index, 1);
                this.$refs.agGrid.gridOptions.api.setRowData(this.agGrid.rows);
                this.$store.dispatch('app-portaldata/UPDATE_ORDER_LINES', this.agGrid.rows.length - 1);
                if (this.agGrid.rows.length == 1)
                    this.agGrid.rows = [];
                this.disableBtn();
            }
        },
        cellKeyPress(event) {
            if (event.event.key === "Enter") {
                const focusedCell = this.$refs.agGrid.gridOptions.api.getFocusedCell();
                if (focusedCell && focusedCell.column.colId === "Qte") {
                    this.showLoading = true; ""
                    this.$store.dispatch('app-portaldata/GET_INVENTORY', { code: event.data.No, qte: event.data.Qte }).then((response) => {
                        this.showLoading = false;
                        this.$store.dispatch('app-portaldata/UPDATE_ORDER_LINES', this.agGrid.rows.length - 1);
                        this.$toast({
                            component: ToastificationContent,
                            props: response,
                        });
                        event.data.promotion = response.promotion;
                        event.data["state"] = !["warning", "danger"].includes(response.variant);
                        var rowNodee = this.$refs.agGrid.gridOptions.api.getDisplayedRowAtIndex(0);
                        this.$refs.agGrid.gridOptions.api.flashCells({
                            rowNodes: [rowNodee],
                            columns: ['Qte'],
                        });
                        this.$refs.agGrid.gridOptions.api.refreshCells()
                        this.$nextTick(() => {
                            this.$refs.productsSelect.$refs["select"].$el.querySelector("input").focus();
                            this.disableBtn();
                        });
                    }).catch((error) => {
                        this.showLoading = false;
                        console.log(error.response);
                    });
                }
            }
        },
        productClicked(data) {
            this.$refs.agGrid.gridOptions.api.setSortModel([]);
            // Refresh the grid to reflect the new sorting
            this.$refs.agGrid.gridOptions.api.refreshClientSideRowModel();
            const existingIndex = this.agGrid.rows.findIndex(row => row.No === data.No);
            if (existingIndex !== -1) {
                // Product already exists, move it to the top
                const existingProduct = this.agGrid.rows.splice(existingIndex, 1)[0];
                existingProduct.Qte = "";
                existingProduct.state = false;
                this.agGrid.rows.unshift(existingProduct);
            } else {
                // Product doesn't exist, add it
                if (this.agGrid.rows.length == 0) {
                    this.agGrid.rows.push({ No: "", total: "" });
                }
                data.state = false;
                data.Qte = "";
                this.agGrid.rows.unshift(data);
            }
            this.$nextTick(() => {
                const rowIndex = 0;
                const colId = "Qte";
                const gridApi = this.$refs.agGrid.gridApi;
                // gridApi.addEventListener("cellKeyPress", this.cellKeyPress);
                gridApi.startEditingCell({ rowIndex, colKey: colId });
                this.disableOrderBtn = true;
            });
        },
        async loadData() {
            this.showLoading = true;
            let cmds = await getOrders();
            cmds = cmds.reverse();
            // const totalObjectIndex = cmds.findIndex(obj => obj.No === '');
            // if (totalObjectIndex !== -1) {
            //     const totalObject = cmds.splice(totalObjectIndex, 1)[0];
            //     cmds.push(totalObject);
            // }
            if (cmds.length != 0) {
                cmds.push({ No: "", total: "" });
            }
            this.agGrid.rows = cmds;
            this.showLoading = false;
            this.$nextTick(() => {
                const gridApi = this.$refs.agGrid.gridApi;
                gridApi.addEventListener("cellKeyPress", this.cellKeyPress);
                this.disableBtn();
            });
        },
        disableBtn() {
            this.disableOrderBtn = this.agGrid.rows.length === 0 ? true : this.agGrid.rows.some((item) => {
                return !item.state && item.No !== "";
            });
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
